import { postLoginMessage } from '@/utils/broadcastMessages';

const postAuthMessage = (isAuthenticated: boolean) => {
  const oauthSignInInitiated = localStorage.getItem('oauth-signin');

  if (isAuthenticated && oauthSignInInitiated) {
    localStorage.removeItem('oauth-signin');
    postLoginMessage();
  }
};

export { postAuthMessage };
